import { createAction } from '@reduxjs/toolkit';

export const productsSectionActions = {
  navigateTo: createAction<{ navigateTo: string }>('ProductsSection/NavigateTo'),
};
